import set from 'lodash/set';

import api from '@/lib/api';

export default {
  async create({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const { id, ...data } = Object.keys(state).reduce((accum, key) => {
      if (state[key]) set(accum, key, state[key]);
      return accum;
    }, {});

    const { payload } = await api.employees.createByCompany(company, data);

    return payload;
  },

  async createBasicEmployee({ state, rootState }) {
    const { companyId: company } = rootState.auth;

    const { id, ...data } = Object.keys(state).reduce((accum, key) => {
      if (state[key]) set(accum, key, state[key]);
      return accum;
    }, {});
    const { payload } = await api.employees.createBasicByCompany(company, data);

    return payload;
  },
};
